import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=be2e0de6&"
import script from "./product-card.vue?vue&type=script&lang=js&"
export * from "./product-card.vue?vue&type=script&lang=js&"
import style0 from "./product-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2e0de6')) {
      api.createRecord('be2e0de6', component.options)
    } else {
      api.reload('be2e0de6', component.options)
    }
    module.hot.accept("./product-card.vue?vue&type=template&id=be2e0de6&", function () {
      api.rerender('be2e0de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-card.vue"
export default component.exports